module.exports = __webpack_public_path__ + "static/media/car.39f30cd7.svg";